import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false
}: CardProps) {
  return <div className={`bg-white rounded-2xl shadow-md border border-brand-light/50 overflow-hidden ${noPadding ? '' : 'p-6 md:p-8'} ${className}`} data-id="element-192">
      {children}
    </div>;
}